var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useReducer } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { getUsersRequest } from "../api/api";
import { SET_USERS, } from "../constants";
import { reducer } from "../reducers/user-reducer";
const initialState = {
    users: [],
    usersSearchValue: "",
};
const UserContext = createContext({
    state: initialState,
    userDispatch: () => { },
    updateUsers: () => __awaiter(void 0, void 0, void 0, function* () { }),
});
const UserContextProvider = ({ children }) => {
    const [state, userDispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        const initialUsers = window.wpqt.initialUsers;
        userDispatch({ type: SET_USERS, payload: initialUsers });
    }, []);
    const updateUsers = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getUsersRequest();
            userDispatch({ type: SET_USERS, payload: response.data });
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to fetch users", "quicktasker"));
        }
    });
    return (_jsx(UserContext.Provider, { value: { state, userDispatch, updateUsers }, children: children }));
};
export { UserContext, UserContextProvider };
